export const conversationalBotRoutePrefixes = [];
